module.exports = __webpack_public_path__ + "static/img/Allevi.7706f05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Allevi.png
// module id = 9qFu
// module chunks = 1